module.exports = __webpack_public_path__ + "img/couple.5862974a.svg";